var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareerPrediction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 70,
    viewBox: "0 0 116 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#B8D1B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6693_11596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#FEF9EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6693_11596)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6693_11596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9068 -15.9319H34.4893V150.126H49.9068V-15.9319Z",
    fill: "#FEBD02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1502 150.37H34.2456V-16.1754H50.1502V150.37ZM34.7326 149.883H49.6632V-15.6885H34.7326V149.883Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7447 -15.9291H65.3271V150.129H80.7447V-15.9291Z",
    fill: "#E9725B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9881 150.373H65.0835V-16.1726H80.9881V150.373ZM65.5705 149.886H80.5011V-15.6856H65.5705V149.886Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.621 97.9638H65.2925V65.2925C65.2925 57.6782 70.2884 49.11 76.9144 45.3602L119.959 21.002L128 35.2136L84.9555 59.5718C83.3971 60.4541 81.6181 63.5021 81.6181 65.2925V97.9638H81.621Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0484 97.9639H65.8657V65.2925C65.8657 57.8702 70.7385 49.514 77.1983 45.8587L100.972 32.4034L108.449 45.618L84.675 59.0733C82.9448 60.053 81.0484 63.3073 81.0484 65.2925V97.9639V97.9639Z",
    fill: "#E9725B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5054 141.286H34.1768V70.6293C34.1768 61.9552 27.1212 54.8966 18.4441 54.8966H-18V38.5681H18.4441C36.1219 38.5681 50.5054 52.9515 50.5054 70.6293V141.286Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9323 141.286H34.7497V70.6293C34.7497 61.64 27.4362 54.3237 18.4441 54.3237H13.915V39.1411H18.4441C35.8067 39.1411 49.9323 53.2667 49.9323 70.6293V141.286Z",
    fill: "#FEBD02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4194 46.1107L14.5254 46.2225L13.9754 46.7324L14.5254 47.2423L14.4194 47.354L13.752 46.7324L14.4194 46.1107Z",
    fill: "#FEBD02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3272 -18.7565H49.9097V147.302H65.3272V-18.7565Z",
    fill: "#CEE8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5706 147.545H49.666V-19H65.5706V147.545ZM50.153 147.058H65.0836V-18.513H50.153V147.058Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7739 103.117H49.4454V32.4607C49.4454 23.7865 42.3897 16.728 33.7127 16.728H-2.73145V0.399445H33.7127C51.3905 0.399445 65.7739 14.7829 65.7739 32.4607V103.117V103.117Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2007 103.117H50.018V32.4607C50.018 23.4714 42.7045 16.1551 33.7124 16.1551H27.0864V0.972382H33.7124C51.075 0.972382 65.2007 15.098 65.2007 32.4607V103.117V103.117Z",
    fill: "#CEE8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5908 7.94495L27.6939 8.05667L27.1439 8.56658L27.6939 9.07362L27.5908 9.18534L26.9233 8.56658L27.5908 7.94495Z",
    fill: "#CEE8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5308 8.79861L23.1362 13.7688V3.8313L14.5308 8.79861Z",
    fill: "#CEE8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3799 14.1899L14.0439 8.7986L23.3799 3.40732V14.1899ZM15.0179 8.7986L22.8929 13.3448V4.24953L15.0179 8.79573V8.7986Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45654 46.8068L10.062 51.7742V41.8367L1.45654 46.8068Z",
    fill: "#FEBD02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3056 52.1981L0.969727 46.8068L10.3056 41.4156V52.1981V52.1981ZM1.94371 46.8068L9.81864 51.353V42.2578L1.94371 46.804V46.8068Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.152 32.9104L110.182 41.5158L105.214 32.9104H115.152Z",
    fill: "#E9725B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.182 42.0028L104.791 32.6669H115.573L110.182 42.0028ZM105.636 33.1539L110.182 41.0288L114.728 33.1539H105.633H105.636Z",
    fill: "#4F4F4F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6693_11596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 169.373,
    fill: "white",
    transform: "translate(-18 -19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerPrediction);
export default __webpack_public_path__ + "static/media/CareerPrediction.c05f300ec537f4bc0e98d09421c31b45.svg";
export { ForwardRef as ReactComponent };